import React, { useRef, useEffect, useState } from "react";

import makeStyles from "@mui/styles/makeStyles";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import LinearProgress from "@mui/material/LinearProgress";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import { createTheme } from "@mui/material";
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import axios from "axios";

const filter = createFilterOptions();

const materialTheme = createTheme({
  // set default for now
});

const useStyles = makeStyles((theme) => ({
  appBarSpacer: theme.mixins.toolbar,
  appBar: {
    position: "fixed",
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  fullWidth: {
    width: "100%",
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function CreateEditAccount(props) {
  const classes = useStyles();
  const [isSavingAccount, setIsSavingAccount] = useState(false);
  const [showMessageDialog, setShowMessageDialog] = useState(false);
  const [isSavingSuccess, setIsSavingSuccess] = useState(false);
  const [messageDialogMessage, setMessageDialogMessage] = useState("");

  const [provinceAutoCompeleteValue, setProvinceAutoCompeleteValue] = useState({
    id: 0,
    provCode: 0,
    provDesc: "",
    psgcCode: "0",
    regCode: "",
  });
  const [provinceAutoCompeleteSuggestion, setProvinceAutoCompeleteSuggestion] = useState([]);
  const [selectedProvince, setSelectedProvince] = useState();

  const [cityMunicipalityAutoCompeleteValue, setCityMunicipalityAutoCompeleteValue] = useState({
    id: 0,
    psgcCode: "",
    citymunDesc: "",
    regDesc: "",
    provCode: "",
    citymunCode: "",
  });
  const [cityMunicipalityAutoCompeleteSuggestion, setCityMunicipalityAutoCompeleteSuggestion] =
    useState([]);
  const [selectedCityMunicipality, setSelectedCityMunicipality] = useState();

  const [barangayAutoCompeleteValue, setBarangayAutoCompeleteValue] = useState({
    id: 0,
    brgyCode: "",
    brgyDesc: "",
    regCode: "",
    provCode: "",
    citymunCode: "",
  });
  const [barangayAutoCompeleteSuggestion, setBarangayAutoCompeleteSuggestion] = useState([]);
  const [selectedBarangay, setSelectedBarangay] = useState();

  const [disableCityMunicipalityAutoSuggest, setDisableCityMunicipalityAutoSuggest] =
    useState(true);
  const [disableBarangayAutoSuggest, setDisableBarangayAutoSuggest] = useState(true);
  const [disableBarangayInput, setDisableBarangayInput] = useState(true);

  const [autoCompleteSearchOptionMessage, setAutoCompleteSearchOptionMessage] =
    useState("Searching...");

  const [accountfieldSettings, setAccountFielAccountSettings] = useState([]);

  const [openAccountClassificationDialog, setOpenAccountClassificationDialog] = useState(false);
  const [accountClassifications, setAccountClassifications] = useState([]);
  const [hasAccountClassification, setHasAccountClassification] = useState(false);

  const [sellerAccount, setSellerAccount] = useState({
    account_name: "",
    account_code: "",
    classification_code: "",
    classification: "",
    province: "",
    city_municipality: "",
    barangay: "",
    street: "",
    name_of_owner: "",
    owner_first_name: "",
    owner_middle_name: "",
    owner_last_name: "",
    contact_number: "",
  });

  const inputOnChangeListener = (event) => {
    const modifiedSellerAccount = { ...sellerAccount };

    modifiedSellerAccount[event.target.name] = event.target.value;
    setSellerAccount(modifiedSellerAccount);
  };

  useEffect(() => {}, [props.accountAction]);

  const saveAccount = (event) => {
    const newSellectAccount = { ...sellerAccount };
    newSellectAccount.province = selectedProvince ? selectedProvince.provDesc : "";
    newSellectAccount.city_municipality = selectedCityMunicipality
      ? selectedCityMunicipality.citymunDesc
      : "";
    newSellectAccount.barangay = selectedBarangay ? selectedBarangay.brgyDesc : "";

    let has_error = false;

    for (const key in newSellectAccount) {
      var field = key;

      if (field === "owner_first_name") {
        field = "first_name";
      }

      if (field === "owner_middle_name") {
        field = "middle_name";
      }

      if (field === "owner_last_name") {
        field = "last_name";
      }

      if (
        (accountfieldSettings.includes(field) && newSellectAccount[key] === "") ||
        newSellectAccount[key] === null
      ) {
        has_error = true;

        if (field === "account_name") {
          field = props.accountsLabel.singular.toLowerCase().replace(/[\s\-\/]/g, "_") + "_name";
        }

        if (field === "account_code") {
          field = props.accountsLabel.singular.toLowerCase().replace(/[\s\-\/]/g, "_") + "_code";
        }

        if (field === "classification") {
          field =
            props.accountClassificationLabel.singular.toLowerCase().replace(/[\s\-\/]/g, "_") +
            "_name";
        }

        let seperated_str = field.replace(/_/g, " ");
        let capitalize_str = seperated_str.charAt(0).toUpperCase() + seperated_str.slice(1);

        setMessageDialogMessage(capitalize_str + " is required.");
        setShowMessageDialog(true);
        return;
      }
    }

    if (has_error) {
      return;
    }

    setIsSavingAccount(true);
    const options = {
      method: "POST",
      url: "/SellerAccounts/createAccounts.json",
      data: objectToFormData(newSellectAccount),
    };
    axios(options)
      .then((res) => {
        const isSuccess = res.data.response.is_success;

        if (!isSuccess) {
          setIsSavingSuccess(false);
          setIsSavingAccount(false);
          setMessageDialogMessage(res.data.response.message);
          setShowMessageDialog(true);

          return;
        }

        setIsSavingSuccess(true);
        setIsSavingAccount(false);
        setMessageDialogMessage("Account save successfully.");
        setShowMessageDialog(true);
      })
      .catch((error) => {
        setIsSavingSuccess(false);
        setIsSavingAccount(false);
        setMessageDialogMessage(error.message);
        setShowMessageDialog(true);
      });
  };

  const updateAccount = (event) => {
    const newSellectAccount = { ...sellerAccount };
    newSellectAccount.province = selectedProvince ? selectedProvince.provDesc : "";
    newSellectAccount.city_municipality = selectedCityMunicipality
      ? selectedCityMunicipality.citymunDesc
      : "";
    newSellectAccount.barangay = selectedBarangay != undefined ? selectedBarangay.brgyDesc : "";

    let has_error = false;
    for (const key in newSellectAccount) {
      var field = key;

      if (field === "owner_first_name") {
        field = "first_name";
      }

      if (field === "owner_middle_name") {
        field = "middle_name";
      }

      if (field === "owner_last_name") {
        field = "last_name";
      }

      if (
        (accountfieldSettings.includes(field) && newSellectAccount[key] === "") ||
        newSellectAccount[key] === null
      ) {
        has_error = true;

        let seperated_str = field.replace(/_/g, " ");
        let capitalize_str = seperated_str.charAt(0).toUpperCase() + seperated_str.slice(1);

        setMessageDialogMessage(capitalize_str + " is required.");
        setShowMessageDialog(true);
        return;
      }
    }

    if (has_error) {
      return;
    }

    setIsSavingAccount(true);
    const options = {
      method: "POST",
      url: "/SellerAccounts/updateAccount.json",
      data: objectToFormData(newSellectAccount),
    };
    axios(options)
      .then((res) => {
        const isSuccess = res.data.response.is_success;

        if (!isSuccess) {
          setIsSavingSuccess(false);
          setIsSavingAccount(false);
          setMessageDialogMessage(res.data.response.message);
          setShowMessageDialog(true);

          return;
        }

        setIsSavingSuccess(true);
        setIsSavingAccount(false);
        setMessageDialogMessage(res.data.response.message);
        setShowMessageDialog(true);
      })
      .catch((error) => {
        setIsSavingSuccess(false);
        setIsSavingAccount(false);
        setMessageDialogMessage(error.message);
        setShowMessageDialog(true);
      });
  };

  const objectToFormData = (object) =>
    Object.keys(object).reduce((formData, key) => {
      formData.append(key, object[key]);

      return formData;
    }, new FormData());

  function progressDialog() {
    return (
      <Dialog fullWidth={true} maxWidth={"lg"} open={isSavingAccount} onClose={() => {}}>
        <DialogContent>
          <DialogContentText>
            Saving {props.accountsLabel.singular}... Please wait...
          </DialogContentText>
          <LinearProgress color="secondary" />
        </DialogContent>
      </Dialog>
    );
  }

  function messageDialog() {
    return (
      <Dialog
        fullWidth={true}
        maxWidth={"sm"}
        open={showMessageDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Message"}</DialogTitle>
        <DialogContent>
          <DialogContentText
            id="alert-dialog-description"
            style={{ color: isSavingSuccess ? "" : "red" }}
          >
            {messageDialogMessage}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setShowMessageDialog(false);

              if (isSavingSuccess) {
                props.setAccountAction("add");
                props.setSelectedAccount(null);
                props.setOpenCreateEditAccount(false);
                props.reloadAccounts();
              }
            }}
            color="primary"
            autoFocus
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  function provinceAutoComplete() {
    return (
      <Autocomplete
        value={provinceAutoCompeleteValue}
        noOptionsText={autoCompleteSearchOptionMessage}
        onChange={(event, newValue) => {
          console.log(newValue);
          if (newValue == null) {
            setSelectedProvince(null);
            return;
          }
          setProvinceAutoCompeleteValue(newValue);
          setSelectedProvince(newValue);
        }}
        filterOptions={(options, params) => {
          return filter(options, params);
        }}
        onOpen={() => {
          setSelectedProvince(null);

          const newCityMunicipalityAutoCompeleteValue = {
            id: 0,
            psgcCode: "",
            citymunDesc: "",
            regDesc: "",
            provCode: "",
            citymunCode: "",
          };
          setCityMunicipalityAutoCompeleteValue(newCityMunicipalityAutoCompeleteValue);

          const newBarangayAutoCompeleteValue = {
            id: 0,
            brgyCode: "",
            brgyDesc: "",
            regCode: "",
            provCode: "",
            citymunCode: "",
          };
          setBarangayAutoCompeleteValue(newBarangayAutoCompeleteValue);

          setDisableCityMunicipalityAutoSuggest(true);
          setDisableBarangayAutoSuggest(true);
          setDisableBarangayInput(true);
        }}
        onClose={(event, reason) => {
          if (reason != "selectOption") {
            // no selected data
            return;
          }

          setDisableCityMunicipalityAutoSuggest(false);
        }}
        selectOnFocus
        clearOnBlur
        handleHomeEndKeys
        // style={{pointerEvents:"none", width: '100%'}}
        options={provinceAutoCompeleteSuggestion}
        isOptionEqualToValue={(option, value) => true}
        getOptionLabel={(option) => {
          return option.provDesc;
        }}
        renderOption={(props, option) => {
          return (
            <li {...props} key={option.provDesc}>
              {option.provDesc}
            </li>
          );
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            InputProps={{ ...params.InputProps, className: classes.fullWidth }}
            className={classes.fullWidth}
            name="province"
            id="province"
            variant="outlined"
            onChange={(event) => {
              const newProvinceAutoCompeleteValue = {
                id: 0,
                provCode: "0",
                provDesc: event.target.value,
                psgcCode: "0",
                regCode: "",
              };

              setProvinceAutoCompeleteValue(newProvinceAutoCompeleteValue);
            }}
          />
        )}
      />
    );
  }

  function cityMunicipalityAutoComplete() {
    return (
      <Autocomplete
        disabled={disableCityMunicipalityAutoSuggest}
        value={cityMunicipalityAutoCompeleteValue}
        noOptionsText={autoCompleteSearchOptionMessage}
        onChange={(event, newValue) => {
          if (newValue === null) {
            const newCityMunicipalityAutoCompeleteValue = {
              id: 0,
              psgcCode: "",
              citymunDesc: "",
              regDesc: "",
              provCode: "",
              citymunCode: "",
            };
            setCityMunicipalityAutoCompeleteValue(newCityMunicipalityAutoCompeleteValue);

            setSelectedCityMunicipality(null);
            return;
          }
          setCityMunicipalityAutoCompeleteValue(newValue);
          setSelectedCityMunicipality(newValue);
        }}
        filterOptions={(options, params) => {
          const filtered = filter(options, params);

          return filtered;
        }}
        selectOnFocus
        clearOnBlur
        handleHomeEndKeys
        onOpen={() => {
          const newCityMunicipalityAutoCompeleteValue = {
            id: 0,
            psgcCode: "",
            citymunDesc: "",
            regDesc: "",
            provCode: "",
            citymunCode: "",
          };
          setCityMunicipalityAutoCompeleteValue(newCityMunicipalityAutoCompeleteValue);

          const newBarangayAutoCompeleteValue = {
            id: 0,
            brgyCode: "",
            brgyDesc: "",
            regCode: "",
            provCode: "",
            citymunCode: "",
          };
          setBarangayAutoCompeleteValue(newBarangayAutoCompeleteValue);

          setDisableBarangayAutoSuggest(true);
          setDisableBarangayInput(true);
        }}
        onClose={(event, reason) => {
          if (reason != "selectOption") {
            // no selected data
            return;
          }

          setDisableBarangayAutoSuggest(false);
        }}
        options={cityMunicipalityAutoCompeleteSuggestion}
        isOptionEqualToValue={(option, value) => true}
        getOptionLabel={(option) => {
          return option.citymunDesc;
        }}
        onSelect={(event, option) => {
          if (selectedCityMunicipality != null || selectedCityMunicipality != undefined) {
            setSelectedCityMunicipality(selectedCityMunicipality);
            setCityMunicipalityAutoCompeleteValue(selectedCityMunicipality);
          } else {
            const newBarangayAutoCompeleteValue = {
              id: 0,
              brgyCode: "",
              brgyDesc: "",
              regCode: "",
              provCode: "",
              citymunCode: "",
            };
            setBarangayAutoCompeleteValue(newBarangayAutoCompeleteValue);
            setSelectedCityMunicipality(null);
          }
        }}
        renderOption={(props, option) => {
          return (
            <li {...props} key={option.citymunDesc}>
              {option.citymunDesc}
            </li>
          );
        }}
        style={{ width: "100%" }}
        renderInput={(params) => (
          <TextField
            {...params}
            InputProps={{ ...params.InputProps, className: classes.fullWidth }}
            className={classes.fullWidth}
            name="city_municipality"
            id="province"
            variant="outlined"
            onChange={(event) => {
              const newCityMunicipalityAutoCompeleteValue = {
                id: 0,
                psgcCode: "",
                citymunDesc: event.target.value,
                regDesc: "",
                provCode: "",
                citymunCode: "",
              };

              setCityMunicipalityAutoCompeleteValue(newCityMunicipalityAutoCompeleteValue);
            }}
          />
        )}
      />
    );
  }

  function barangayAutoComplete() {
    return (
      <Autocomplete
        disabled={disableBarangayAutoSuggest}
        value={barangayAutoCompeleteValue}
        noOptionsText={"No record found"}
        onChange={(event, newValue) => {
          console.log("newValue", newValue);
          if (newValue === null) {
            const newBarangayAutoCompeleteValue = {
              id: 0,
              brgyCode: "",
              brgyDesc: "",
              regCode: "",
              provCode: "",
              citymunCode: "",
            };
            setBarangayAutoCompeleteValue(newBarangayAutoCompeleteValue);

            setSelectedBarangay(null);
            return;
          }
          setBarangayAutoCompeleteValue(newValue);
          setSelectedBarangay(newValue);
        }}
        filterOptions={(options, params) => {
          const filtered = filter(options, params);

          return filtered;
        }}
        selectOnFocus
        clearOnBlur
        handleHomeEndKeys
        options={barangayAutoCompeleteSuggestion}
        onOpen={() => {
          const newBarangayAutoCompeleteValue = {
            id: 0,
            brgyCode: "",
            brgyDesc: "",
            regCode: "",
            provCode: "",
            citymunCode: "",
          };
          setBarangayAutoCompeleteValue(newBarangayAutoCompeleteValue);
          setDisableBarangayInput(true);
        }}
        onClose={(event, reason) => {
          if (reason != "selectOption") {
            // no selected data
            return;
          }

          setDisableBarangayInput(false);
        }}
        isOptionEqualToValue={(option, value) => true}
        getOptionLabel={(option) => {
          return option.brgyDesc;
        }}
        onSelect={(event, option) => {
          if (selectedBarangay != null || selectedBarangay != undefined) {
            setSelectedBarangay(selectedBarangay);
            setBarangayAutoCompeleteValue(selectedBarangay);
          }
        }}
        renderOption={(props, option) => {
          return (
            <li {...props} key={option.brgyDesc}>
              {option.brgyDesc}
            </li>
          );
        }}
        style={{ width: "100%" }}
        renderInput={(params) => (
          <TextField
            {...params}
            InputProps={{ ...params.InputProps, className: classes.fullWidth }}
            className={classes.fullWidth}
            name="city_municipality"
            id="province"
            variant="outlined"
            onChange={(event) => {
              const newBarangayAutoCompeleteValue = {
                id: 0,
                brgyCode: "",
                brgyDesc: event.target.value,
                regCode: "",
                provCode: "",
                citymunCode: "",
              };

              setBarangayAutoCompeleteValue(newBarangayAutoCompeleteValue);
            }}
          />
        )}
      />
    );
  }
  useEffect(() => {
    if (provinceAutoCompeleteValue == null) {
      fetchAutoSuggestProvinces("");
    } else {
      fetchAutoSuggestProvinces(provinceAutoCompeleteValue.provDesc);
    }
  }, [provinceAutoCompeleteValue]);
  useEffect(() => {
    if (selectedProvince == null) {
      return;
    }

    if (cityMunicipalityAutoCompeleteValue == null) {
      fetchAutoSuggestCitiesMunicipalities(selectedProvince.provCode, "");
    } else {
      fetchAutoSuggestCitiesMunicipalities(
        selectedProvince.provCode,
        cityMunicipalityAutoCompeleteValue.citymunDesc
      );
    }
  }, [cityMunicipalityAutoCompeleteValue]);

  useEffect(() => {
    if (selectedProvince == null || selectedCityMunicipality == null) {
      return;
    }

    if (barangayAutoCompeleteValue == null) {
      fetchAutoSuggestBarangays(
        selectedProvince.provCode,
        selectedCityMunicipality.citymunCode,
        ""
      );
    } else {
      fetchAutoSuggestBarangays(
        selectedProvince.provCode,
        selectedCityMunicipality.citymunCode,
        barangayAutoCompeleteValue.brgyDesc
      );
    }
  }, [barangayAutoCompeleteValue]);

  useEffect(() => {
    getAccountFieldSettings();
    getAccountClassifications();
  }, []);

  async function getAccountFieldSettings() {
    const options = {
      method: "POST",
      url: "/SellerAccounts/getAccountRequiredFieldSettings.json",
      data: objectToFormData({ search_term: "" }),
    };

    try {
      const response = await axios(options);
      const settings = response.data.response.account_field_settings;
      setAccountFielAccountSettings(settings);
    } catch (error) {
      console.error("Error fetching account field settings:", error);
    }
  }

  async function getAccountClassifications() {
    const options = {
      method: "POST",
      url: "/SellerAccounts/getAccountClassification.json",
      data: objectToFormData({ search_term: "" }),
    };

    try {
      const response = await axios(options);
      const responseResult = response.data.result;
      const isSuccess = responseResult.is_success;

      if (isSuccess) {
        const account_classifications = responseResult.account_classifications;

        setAccountClassifications(account_classifications);
        setHasAccountClassification(account_classifications.length > 0);
      }
    } catch (error) {
      console.error("Error fetching account classifications", error);
    }
  }
  useEffect(() => {}, [accountfieldSettings]);

  function fetchAutoSuggestProvinces(searchString) {
    const ourRequest = axios.CancelToken.source(); // <-- 1st step

    const getProvinces = async () => {
      setAutoCompleteSearchOptionMessage("Searching");

      const options = {
        method: "POST",
        url: "/SellerAccounts/getProvinceForAutoSuggest.json",
        cancelToken: ourRequest.token,
        data: objectToFormData({ search_term: searchString }),
      };
      const response = await axios(options)
        .then((res) => {
          const provinces = res.data.response.Provinces;
          if (provinces.length <= 0) {
            setAutoCompleteSearchOptionMessage("No record found.");

            setProvinceAutoCompeleteSuggestion([]);
          } else {
            setProvinceAutoCompeleteSuggestion(provinces);
          }
        })
        .catch((error) => {
          // alert("error")
          console.log(error);
        });
    };
    getProvinces();

    return () => {
      if (ourRequest !== undefined) {
        ourRequest.cancel(); //
      }
    };
  }
  function fetchAutoSuggestCitiesMunicipalities(provinceCode, searchString) {
    const ourRequest = axios.CancelToken.source(); // <-- 1st step

    const getCitiesMunicipalities = async () => {
      setAutoCompleteSearchOptionMessage("Searching");

      const options = {
        method: "POST",
        url: "/SellerAccounts/getCitiesMunicipalitiesForAutoSuggest.json",
        cancelToken: ourRequest.token,
        data: objectToFormData({ provCode: provinceCode, search_term: searchString }),
      };
      const response = await axios(options)
        .then((res) => {
          const citiesMunicipalities = res.data.response.CitiesMunicipalities;
          if (citiesMunicipalities.length <= 0) {
            setAutoCompleteSearchOptionMessage("No record found.");

            setCityMunicipalityAutoCompeleteSuggestion([]);
          } else {
            setCityMunicipalityAutoCompeleteSuggestion(citiesMunicipalities);
          }
        })
        .catch((error) => {
          // alert("error")
          console.log(error);
        });
    };
    getCitiesMunicipalities();

    return () => {
      if (ourRequest !== undefined) {
        ourRequest.cancel();
      }
    };
  }
  function fetchAutoSuggestBarangays(provinceCode, cityMunicipalityCode, searchString) {
    const ourRequest = axios.CancelToken.source(); // <-- 1st step

    const getBarangays = async () => {
      setAutoCompleteSearchOptionMessage("Searching");

      const options = {
        method: "POST",
        url: "/SellerAccounts/getBarangaysForAutoSuggest.json",
        cancelToken: ourRequest.token,
        data: objectToFormData({
          provCode: provinceCode,
          cityMunicipalityCode: cityMunicipalityCode,
          search_term: searchString,
        }),
      };
      const response = await axios(options)
        .then((res) => {
          const barangays = res.data.response.Barangays;

          if (barangays.length <= 0) {
            setAutoCompleteSearchOptionMessage("No record found.");

            setBarangayAutoCompeleteSuggestion([]);
          } else {
            setBarangayAutoCompeleteSuggestion(barangays);
          }
        })
        .catch((error) => {
          // alert("error")
          console.log(error);
        });
    };
    getBarangays();

    return () => {
      if (ourRequest !== undefined) {
        ourRequest.cancel();
      }
    };
  }

  useEffect(() => {
    if (props.accountAction == null || props.accountAction == "add") {
      return;
    }
    getAccountInformationWithAddress();
  }, [props.accountAction]);

  function getAccountInformationWithAddress() {
    const options = {
      method: "POST",
      url: "/SellerAccounts/getAccountInformationWithAddressInformation.json",
      data: objectToFormData(props.selectedAccount),
    };
    axios(options)
      .then((res) => {
        const response = res.data.response;
        const isSuccess = response.is_success;

        if (!isSuccess) {
          alert("Error encounter");

          // setIsSavingSuccess(false)
          // setIsSavingAccount(false)
          // setMessageDialogMessage(res.data.response.message)
          // setShowMessageDialog(true)

          return;
        }

        if (response.hasOwnProperty("Province")) {
          setSelectedProvince(response.Province);
          setProvinceAutoCompeleteValue(response.Province);
        }
        if (response.hasOwnProperty("CityMunipality")) {
          setSelectedCityMunicipality(response.CityMunipality);
          setCityMunicipalityAutoCompeleteValue(response.CityMunipality);
          setDisableCityMunicipalityAutoSuggest(false);
        }
        if (response.hasOwnProperty("Barangay")) {
          setSelectedBarangay(response.Barangay);
          setBarangayAutoCompeleteValue(response.Barangay);
          setDisableBarangayAutoSuggest(false);
          setDisableBarangayInput(false);
        }

        const sellerAccountCopy = { ...sellerAccount };
        sellerAccountCopy.id = props.selectedAccount.id;
        sellerAccountCopy.auto_generated_id = props.selectedAccount.auto_generated_id;
        sellerAccountCopy.account_name = props.selectedAccount.account_name;
        sellerAccountCopy.account_code = props.selectedAccount.account_code;
        sellerAccountCopy.classification_code = props.selectedAccount.classification_code;
        sellerAccountCopy.classification = props.selectedAccount.classification;
        sellerAccountCopy.owner_first_name = props.selectedAccount.owner_first_name;
        sellerAccountCopy.owner_last_name = props.selectedAccount.owner_last_name;
        sellerAccountCopy.owner_middle_name = props.selectedAccount.owner_middle_name;
        sellerAccountCopy.contact_number = props.selectedAccount.contact_number;
        sellerAccountCopy.street = props.selectedAccount.street;

        setSellerAccount(sellerAccountCopy);
      })
      .catch((error) => {
        // setIsSavingSuccess(false)
        alert("Error encounter");
        console.log(error);
      });
  }

  function accountClassificationDialog() {
    return (
      <Dialog
        fullWidth={true}
        open={openAccountClassificationDialog}
        onClose={() => {
          setOpenAccountClassificationDialog(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Classification"}</DialogTitle>
        <DialogContent>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <List>
                {accountClassifications.map((account_classification, index) => {
                  return (
                    <ListItemButton
                      divider
                      key={index}
                      onClick={() => {
                        const modifiedSellerAccount = { ...sellerAccount };
                        modifiedSellerAccount["classification"] = account_classification.name;
                        modifiedSellerAccount["classification_code"] = account_classification.code;
                        setSellerAccount(modifiedSellerAccount);
                        setOpenAccountClassificationDialog(false);
                      }}
                    >
                      {account_classification.name} ({account_classification.code})
                    </ListItemButton>
                  );
                })}
              </List>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpenAccountClassificationDialog(false);
            }}
            color="primary"
            autoFocus
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  function accountClassificationText() {
    if (hasAccountClassification) {
      return (
        <TextField
          className={classes.fullWidth}
          value={sellerAccount.classification}
          name="account_classification"
          id="account-classification"
          rows={4}
          variant="outlined"
          onClick={() => {
            setOpenAccountClassificationDialog(true);
          }}
          onChange={inputOnChangeListener}
          inputProps={{ readOnly: true }}
        />
      );
    } else {
      return (
        <TextField
          className={classes.fullWidth}
          value={sellerAccount.classification}
          name="classification"
          id="account-classification"
          rows={4}
          variant="outlined"
          onChange={inputOnChangeListener}
        />
      );
    }
  }
  return (
    <>
      <div>
        <Dialog
          fullScreen
          open={props.openCreateEditAccount}
          onClose={() => {
            props.setAccountActionListener("add");
          }}
          TransitionComponent={Transition}
        >
          <AppBar className={classes.appBar}>
            <Toolbar>
              <IconButton
                edge="start"
                color="inherit"
                onClick={() => {
                  props.setAccountAction("add");
                  props.setSelectedAccount(null);
                  props.setOpenCreateEditAccount(false);
                }}
                aria-label="close"
                size="large"
              >
                <CloseIcon />
              </IconButton>
              <Typography variant="subtitle1" className={classes.title}>
                {props.accountAction == "add"
                  ? `Create ${props.accountsLabel.singular}`
                  : `Update ${props.accountsLabel.singular}`}
              </Typography>
            </Toolbar>
          </AppBar>
          <div className={classes.appBarSpacer}></div>
          <div style={{ padding: ".5rem" }}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                {props.accountsLabel.singular} Name*
              </Grid>
              <Grid item xs={12}>
                <StyledEngineProvider injectFirst>
                  <ThemeProvider theme={materialTheme}>
                    <form noValidate>
                      <TextField
                        className={classes.fullWidth}
                        value={sellerAccount.account_name}
                        name="account_name"
                        id="account-name"
                        rows={4}
                        variant="outlined"
                        onChange={inputOnChangeListener}
                      />
                    </form>
                  </ThemeProvider>
                </StyledEngineProvider>
              </Grid>

              <Grid item xs={12}>
                {props.accountsLabel.singular} Code*
              </Grid>
              <Grid item xs={12}>
                <StyledEngineProvider injectFirst>
                  <ThemeProvider theme={materialTheme}>
                    <form noValidate>
                      <TextField
                        disabled={props.accountAction === "edit" && true}
                        className={classes.fullWidth}
                        value={sellerAccount.account_code}
                        name="account_code"
                        id="account-code"
                        rows={4}
                        variant="outlined"
                        onChange={inputOnChangeListener}
                      />
                    </form>
                  </ThemeProvider>
                </StyledEngineProvider>
              </Grid>
              <Grid item xs={12}>
                {props.accountClassificationLabel.singular} Name
                {accountfieldSettings.includes("classification") ? "*" : ""}
              </Grid>
              <Grid item xs={12}>
                <StyledEngineProvider injectFirst>
                  <ThemeProvider theme={materialTheme}>
                    <form noValidate>{accountClassificationText()}</form>
                  </ThemeProvider>
                </StyledEngineProvider>
              </Grid>

              <Grid item xs={12}>
                Province {accountfieldSettings.includes("province") ? "*" : ""}
              </Grid>
              <Grid item xs={12}>
                <StyledEngineProvider injectFirst>
                  <ThemeProvider theme={materialTheme}>
                    <form noValidate>{provinceAutoComplete()}</form>
                  </ThemeProvider>
                </StyledEngineProvider>
              </Grid>

              <Grid item xs={12}>
                City/ Municipality{accountfieldSettings.includes("city_municipality") ? "*" : ""}
              </Grid>
              <Grid item xs={12}>
                <StyledEngineProvider injectFirst>
                  <ThemeProvider theme={materialTheme}>
                    <form noValidate>{cityMunicipalityAutoComplete()}</form>
                  </ThemeProvider>
                </StyledEngineProvider>
              </Grid>

              <Grid item xs={12}>
                Barangay{accountfieldSettings.includes("barangay") ? "*" : ""}
              </Grid>
              <Grid item xs={12}>
                <StyledEngineProvider injectFirst>
                  <ThemeProvider theme={materialTheme}>
                    <form noValidate>{barangayAutoComplete()}</form>
                  </ThemeProvider>
                </StyledEngineProvider>
              </Grid>

              <Grid item xs={12}>
                Street{accountfieldSettings.includes("street") ? "*" : ""}
              </Grid>
              <Grid item xs={12}>
                <StyledEngineProvider injectFirst>
                  <ThemeProvider theme={materialTheme}>
                    <form noValidate>
                      <TextField
                        value={sellerAccount.street}
                        disabled={disableBarangayInput}
                        className={classes.fullWidth}
                        name="street"
                        id="street"
                        rows={4}
                        variant="outlined"
                        onChange={inputOnChangeListener}
                      />
                    </form>
                  </ThemeProvider>
                </StyledEngineProvider>
              </Grid>

              <Grid container spacing={1}>
                <Grid item xs={4}>
                  <Grid item xs={12}>
                    First name{accountfieldSettings.includes("first_name") ? "*" : ""}
                  </Grid>
                  <Grid item xs={12}>
                    <StyledEngineProvider injectFirst>
                      <ThemeProvider theme={materialTheme}>
                        <form noValidate>
                          <TextField
                            autoComplete="off"
                            type="text"
                            className={classes.fullWidth}
                            value={sellerAccount.owner_first_name}
                            name="owner_first_name"
                            id="first-name"
                            rows={4}
                            variant="outlined"
                            onChange={inputOnChangeListener}
                          />
                        </form>
                      </ThemeProvider>
                    </StyledEngineProvider>
                  </Grid>
                </Grid>
                <Grid item xs={4}>
                  <Grid item xs={12}>
                    Middle name{accountfieldSettings.includes("middle_name") ? "*" : ""}
                  </Grid>
                  <Grid item xs={12}>
                    <StyledEngineProvider injectFirst>
                      <ThemeProvider theme={materialTheme}>
                        <form noValidate>
                          <TextField
                            autoComplete="off"
                            className={classes.fullWidth}
                            value={sellerAccount.owner_middle_name}
                            name="owner_middle_name"
                            id="middle-name"
                            rows={4}
                            variant="outlined"
                            onChange={inputOnChangeListener}
                          />
                        </form>
                      </ThemeProvider>
                    </StyledEngineProvider>
                  </Grid>
                </Grid>
                <Grid item xs={4}>
                  <Grid item xs={12}>
                    Last name{accountfieldSettings.includes("last_name") ? "*" : ""}
                  </Grid>
                  <Grid item xs={12}>
                    <StyledEngineProvider injectFirst>
                      <ThemeProvider theme={materialTheme}>
                        <form noValidate>
                          <TextField
                            autoComplete="off"
                            className={classes.fullWidth}
                            value={sellerAccount.owner_last_name}
                            name="owner_last_name"
                            id="last-name"
                            rows={4}
                            variant="outlined"
                            onChange={inputOnChangeListener}
                          />
                        </form>
                      </ThemeProvider>
                    </StyledEngineProvider>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12}>
                Contact Number{accountfieldSettings.includes("contact_number") ? "*" : ""}
              </Grid>
              <Grid item xs={12}>
                <StyledEngineProvider injectFirst>
                  <ThemeProvider theme={materialTheme}>
                    <form noValidate>
                      <TextField
                        className={classes.fullWidth}
                        value={sellerAccount.contact_number}
                        name="contact_number"
                        id="contact-number"
                        rows={4}
                        variant="outlined"
                        onChange={inputOnChangeListener}
                      />
                    </form>
                  </ThemeProvider>
                </StyledEngineProvider>
              </Grid>

              <Grid item container>
                <Button
                  variant="contained"
                  color="primary"
                  style={{ width: "100%" }}
                  onClick={props.accountAction == "add" ? saveAccount : updateAccount}
                >
                  Save
                </Button>
              </Grid>
            </Grid>
          </div>
        </Dialog>
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={materialTheme}>
            {progressDialog()}
            {messageDialog()}
            {accountClassificationDialog()}
          </ThemeProvider>
        </StyledEngineProvider>
      </div>
    </>
  );
}

export default CreateEditAccount;
